<template>
  <div class="studentDetail">
    <Header
      title="任务详情"
      type="0"
      :route="'/taskAdd/item?list=' + params"
    ></Header>
    <NOdata
      v-if="this.list && this.list.length == 0"
      title="未查询到实习任务"
    ></NOdata>
    <div v-else class="list-item">
      <div class="content" v-for="(item, index) in list" :key="index">
        <div class="top">
          <p>任务要求：</p>
          <ul>
            <li>{{ item.rwnr == "" ? "暂无任务要求" : item.rwnr }}</li>
          </ul>
          <p>学生任务完成填报：</p>
          <ul>
            <li>
              {{ item.xspy == "" ? "暂无学生任务完成填报内容" : item.xspy }}
            </li>
          </ul>
          <p>教师评价：</p>
          <ul>
            <li>{{ item.jspjnr == "" ? "暂无教师评价" : item.jspjnr }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Api } from "@/utils/axios";

export default {
  data() {
    return {
      list: [],
      params: {}
    };
  },
  methods: {
    async getList() {
      const res = await Api.getsxrwxspjmx({
        rwfbid: this.$route.query.list.rwfbid,
        xs0101id: this.$route.query.list.xs0101id
      });
      this.list = res.data;
    }
  },
  created() {
    this.getList();
    this.params = JSON.stringify({
      id: this.$route.query.list.rwfbid,
      title: this.$route.query.list.title
    });
  }
};
</script>
<style lang="less" scoped>
.studentDetail {
  .research {
    z-index: 9999;
    position: fixed;
    top: 50px;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #f4f4f4;
    padding: 5% 5% 3% 5%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-color: #fff;

    span {
      height: 20px;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #757da3;
      letter-spacing: 0;
      text-align: right;
      display: inline-flex;
      align-items: center;
      i {
        font-style: normal;
      }
      b {
        display: inline-block;
        border-right: 3px solid transparent;
        border-left: 3px solid transparent;
        border-top: 3px solid #757da3;
      }
    }
  }
  .list-item {
    padding: 0px 20px 0 20px;
    .content {
      background: #f8f8f8;
      border-radius: 5px;
      margin-bottom: 5%;
      .top {
        padding: 20px 20px 10px 20px;
        p {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #212f6e;
          letter-spacing: 0;
          font-weight: bolder;
          margin-bottom: 10px;
        }
        ul li {
          height: 17px;
          font-family: PingFangSC-Light;
          font-size: 12px;
          color: #757da3;
          letter-spacing: 0;
          margin-bottom: 5px;
        }
      }
    }
  }
  .icon {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/taskAdd/studentDetail.vue